import { Scene, SceneAudioItem } from '@monorepo/types';
import { FunctionComponent, useRef } from 'react';
import { Flex, Tag, Tooltip } from 'antd';
import { SoundOutlined } from '@ant-design/icons';
import AudioModal, {
  AudioModalActions,
} from '../../../../../audio-modal/audio-modal';
import SceneItemWrapper from '../scene-item-wrapper';
import { useTranslation } from 'react-i18next';

interface Props {
  data: SceneAudioItem;
  scene: Scene;
  itemIndex: number;
}

const SceneAudio: FunctionComponent<Props> = ({ data, scene, itemIndex }) => {
  const { t } = useTranslation();
  const audioModalRef = useRef<AudioModalActions>(null);

  const handleAudioClick = () => {
    audioModalRef.current?.open();
  };

  return (
    <SceneItemWrapper
      sceneId={scene._id}
      sceneItemIndex={itemIndex}
      openModal={handleAudioClick}
    >
      <Flex className={`scene-audio`}>
        <Tooltip title={t('videoEditor.sceneAudio.clickToChange')}>
          <Tag
            icon={<SoundOutlined />}
            color="blue"
            style={{ cursor: 'pointer' }}
            onClick={handleAudioClick}
          >
            {data.url
              ? data.name || t('videoEditor.sceneAudio.selectAudio')
              : t('videoEditor.sceneAudio.selectAudio')}
          </Tag>
        </Tooltip>

        <AudioModal
          sceneId={scene._id}
          itemIndex={itemIndex}
          videoId={scene.videoId}
          ref={audioModalRef}
        />
      </Flex>
    </SceneItemWrapper>
  );
};

export default SceneAudio;
